import { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ScrollToTop from '@/shared/components/ScrollToTop';
import ProtectedRoute from './ProtectedRoute';
import CreateExpenseVoucher from '@/views/CreateExpenseVoucher/CreateExpenseVoucher';
import Expenses from '@/views/Expenses/Expenses';
import AssignUserPrivileges from '@/views/AssignUserPrivileges/AssignUserPrivileges';
import Reports from '@/views/Reports/Reports';

const NotFoundPage = lazy(() => import('@/views/NotFound/NotFoundPage'));
const Orders = lazy(() => import('@/views/Orders/Orders'));
const OrderImages = lazy(() => import('@/views/Orders/OrderImages'));
const HomePage = lazy(() => import('@/views/Home/HomePage'));
const CreateOrder = lazy(() => import('@/views/Orders/CreateOrder/CreateOrder'));
const PreparingPieces = lazy(() => import('@/views/PreparingPieces/PreparingPieces'));
const EditOrder = lazy(() => import('@/views/Orders/EditOrder'));
const ReadyOrders = lazy(() => import('@/views/Orders/ReadyOrders'));
const PartialOrderPieces = lazy(() => import('@/views/PartialOrderPieces/PartialOrderPieces'));
const SalesProfits = lazy(() => import('@/views/SalesProfits/SalesProfits'));
const ShippingZonesManagement = lazy(() => import('@/views/ShippingZonesManagement/ShippingZonesManagement'));
const Activities = lazy(() => import('@/views/Activities/Activities'));
const AuditPieces = lazy(() => import('@/views/AuditPieces/AuditPieces'));
const OrderTracking = lazy(() => import('@/views/Orders/OrderTracking'));
const ItemSalesReport = lazy(() => import('@/views/ItemSalesReport/ItemSalesReport'));
const Unauthorized = lazy(() => import('@/views/Unauthorized/Unauthorized'));

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p></p>
      </div>}>
        <Routes>

          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<HomePage />} />
          </Route>

          {/* <Route element={<ProtectedRoute page="sales_profits" />}>
            <Route path="/sales_profits" element={<SalesProfits />} />
          
            <Route path="/assign_user_privileges" element={<AssignUserPrivileges />} />

          </Route> */}
          <Route element={<ProtectedRoute page="reports" />}>
            <Route path="/add_payment_voucher" element={<CreateExpenseVoucher />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path='/reports' element={<Reports />} />
          </Route>

          <Route element={<ProtectedRoute page="shipping_zones_management" />}>
            <Route path='/shipping_zones_management' element={<ShippingZonesManagement />} />
          </Route>

          <Route element={<ProtectedRoute page="activities" />}>
            <Route path='/activities' element={<Activities />} />
          </Route>

          <Route element={<ProtectedRoute page="pieces_audit" />}>
            <Route path="/pieces_audit" element={<AuditPieces />} />
          </Route>

          <Route element={<ProtectedRoute page="item_sales_report" />}>
            <Route path="/item_sales_report" element={<ItemSalesReport />} />

          </Route>

          <Route element={<ProtectedRoute page="orders" />}>
            <Route path="/order_tracking/:id" element={<OrderTracking />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/create_order" element={<CreateOrder />} />
            <Route path="/ready_orders" element={<ReadyOrders />} />
            <Route path="/order_images/:id/:images_count" element={<OrderImages />} />
            <Route path="/edit_order/:id/:name" element={<EditOrder />} />
            <Route path="/partial_order_pieces" element={<PartialOrderPieces />} />
          </Route>

          <Route element={<ProtectedRoute page="preparing_pieces" />}>
            <Route path="/preparing_pieces" element={<PreparingPieces />} />
          </Route>

          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};